import { cn } from '@avanta/shared/utils/cn';
import { ChevronRight } from 'lucide-react';
import { type ComponentProps, type ReactElement } from 'react';
import { Link } from 'react-router';

const BreadcrumbSeparator = ({
  children,
  className,
  ...props
}: ComponentProps<'span'>): ReactElement => (
  <span
    data-slot="breadcrumb-separator"
    role="presentation"
    aria-hidden="true"
    className={cn('[&>svg]:size-3.5', className)}
    {...props}
  >
    {children ?? <ChevronRight />}
  </span>
);

export const Breadcrumb = ({
  links,
  ...props
}: {
  links: { href: string; label: string }[];
}): ReactElement => (
  <nav aria-label="breadcrumb" data-slot="breadcrumb" {...props}>
    <ol
      data-slot="breadcrumb-list"
      className="text-gray-600 flex flex-wrap items-center gap-1.5 text-sm wrap-break-word sm:gap-2.5"
      {...props}
    >
      {links.map((link, index) => (
        <li
          data-slot="breadcrumb-item"
          className="inline-flex items-center gap-1.5"
          key={link.href}
        >
          <Link to={link.href}>{link.label}</Link>
          {index < links.length - 1 && <BreadcrumbSeparator />}
        </li>
      ))}
    </ol>
  </nav>
);
